import { DeviceType } from '@/app/util/env'
import { IGif, IImage } from '@giphy/js-types'

/**
 * Retrieves the banner media URL, rendition, and file type from the given GIF.
 */
export const getAdBannerData = (gif: IGif, deviceType?: DeviceType) => {
    /*
     * Workaround for asserting the existence of a source
     * image inside the images array because it is not exposed
     * in the web-sdk.
     */
    const extendedGif = gif as IGif & {
        images: {
            source?: IImage
        }
    }

    const rendition = deviceType === 'desktop' ? 'source' : 'original'
    const url = extendedGif.images[rendition]?.url
    if (!url) throw new Error(`Ad Banner: missing ${rendition} rendition for ${gif.id}`)

    const parsed = new URL(url)
    const fileType = parsed.pathname.endsWith('.mp4') ? 'video' : 'image'

    return { url, fileType, rendition }
}
